import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import {CommunicationType} from './communication-type';
import {map} from 'rxjs/operators';
import {ConfigUtil} from '@shared/services/config.util';

@Injectable({
  providedIn: 'root'
})
export class CommunicationTypeApi {
  private readonly httpClient = inject(HttpClient);

  private readonly endpoint: string;

  constructor() {
    this.endpoint = `${ConfigUtil.get('api')['backend']}/communication-types`;

  }

  public findAll(): Observable<CommunicationType[]> {
    return this.httpClient.get<CommunicationType[]>(`${this.endpoint}`);
  }

  public findById(id: number): Observable<CommunicationType> {
    return this.httpClient.get<CommunicationType>(`${this.endpoint}/${id}`).pipe(map(value => {
      return Object.assign(new CommunicationType(), value);
    }));
  }

  public findByAdministration(administrationUuid: string): Observable<CommunicationType[]> {
    return this.httpClient.get<CommunicationType[]>(`${this.endpoint}?administration=${administrationUuid}`);
  }

  public save(administrationUuid: string, communicationType: CommunicationType): Observable<CommunicationType> {
    const url = `${this.endpoint}?administration=${administrationUuid}`;
    return this.httpClient.post<CommunicationType>(url, communicationType).pipe(map(value => {
      return Object.assign(new CommunicationType(), value);
    }));
  }

  public update(communicationType: CommunicationType): Observable<boolean> {
    return this.httpClient.put<boolean>(`${this.endpoint}/${communicationType.id}`, communicationType);
  }
}
